/* --------------------------------------------------------------------------
	Share Tools
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

var Share = (function ($, Site) {
	var $Options, $Toggle, $Tools, $Share_tools;

	function init() {
		$Tools = $('.js-share-tools');

		if (!$Tools.length) {
			return;
		}

		$Options = $('.js-share-tools-list');
		$Toggle = $('.js-share-tools-toggle');

		$Toggle.on('click', onToggleClick).on('keydown', onToggleKeydown);

		if (typeof navigator.share === 'undefined') {
			$Toggle.attr({ 'aria-haspopup': 'true', 'aria-expanded': 'false' }).swap();
			$Options.attr('aria-hidden', 'true').on('keydown', onOptionsKeydown);
			$('.js-share-tool').attr('tabindex', '-1');
		}
	}

	function onToggleClick() {
		$Share_tools = $(this).closest('.js-share-tools');

		if (typeof navigator.share === 'undefined') {
			setTimeout(function () {
				if ($Share_tools.hasClass('fs-swap-active')) {
					openOptions();

					$Share_tools.find('.js-share-tool-item:first-child').transition({ always: false, property: 'opacity' }, function () {
						$Share_tools.find('.js-share-tool').first().focus();
					});
				} else {
					closeOptions();
				}
			}, 0);
		} else {
			navigator.share({
				title: encodeURIComponent($('title').text()),
				text: $('meta[property="og:description"]').attr('content'),
				url: window.location.href
			});
		}
	}

	function onToggleKeydown(e) {
		$Share_tools = $(this).closest('.js-share-tools');
		var key = e.keyCode;

		if (key !== 38 && key !== 40) {
			return;
		}

		if (typeof navigator.share === 'undefined') {
			e.preventDefault();

			if (!$Share_tools.hasClass('fs-swap-active')) {
				$Share_tools.find('.js-share-tools-toggle').swap('activate');

				openOptions();
			}

			// up
			if (key === 38) {
				if ($Share_tools.hasClass('fs-swap-active')) {
					$Share_tools.find('.js-share-tool-item:last-child').transition({ always: false, property: 'opacity' }, function () {
						$Share_tools.find('.js-share-tool').last().focus();
					});
				}
				// down
			} else {
				if ($Share_tools.hasClass('fs-swap-active')) {
					$Share_tools.find('.js-share-tool-item:first-child').transition({ always: false, property: 'opacity' }, function () {
						$Share_tools.find('.js-share-tool').first().focus();
					});
				}
			}
		}
	}

	function onOptionsKeydown(e) {
		$Share_tools = $(this).closest('.js-share-tools');
		var key = e.keyCode;
		var focusedIndex = $(':focus').closest('.js-share-tool-item').index();

		if ([27, 38, 40, 36, 35].indexOf(key) === -1) {
			return;
		}

		e.preventDefault();

		switch (key) {
			// escape
			case 27:
				$Share_tools.find('.js-share-tools-toggle').swap('deactivate').focus();
				closeOptions();

				break;
			// up
			case 38:
				if (focusedIndex > 0) {
					$Share_tools
						.find('.js-share-tool')
						.eq(focusedIndex - 1)
						.focus();
				} else {
					$Share_tools.find('.js-share-tool').last().focus();
				}

				break;
			// down
			case 40:
				if (!$(':focus').closest('.js-share-tool-item').is(':last-of-type')) {
					$Share_tools
						.find('.js-share-tool')
						.eq(focusedIndex + 1)
						.focus();
				} else {
					$Share_tools.find('.js-share-tool').first().focus();
				}

				break;
			// home
			case 36:
				$Share_tools.find('.js-share-tool').first().focus();

				break;
			// end
			case 35:
				$Share_tools.find('.js-share-tool').last().focus();

				break;
		}
	}

	function openOptions() {
		$Share_tools.find('.js-share-tools-toggle').attr('aria-expanded', 'true');

		$Share_tools.find('.js-share-tools-list').attr('aria-hidden', 'false').find('.js-share-tool').removeAttr('tabindex');
	}

	function closeOptions() {
		$Share_tools.find('.js-share-tools-toggle').attr('aria-expanded', 'false').focus();

		$Share_tools.find('.js-share-tools-list').attr('aria-hidden', 'true').find('.js-share-tool').attr('tabindex', '-1');
	}

	function populateUrls() {
		var url = $('meta[property="og:url"]').attr('content');
		var title = $('meta[property="og:title"]').attr('content');

		if (!url) {
			url = window.location.href;
		}
		if (!title) {
			title = encodeURIComponent($('title').text());
		}

		$('.js-share-facebook').attr('href', '//www.facebook.com/sharer/sharer.php?u=' + url);
		$('.js-share-twitter').attr('href', '//twitter.com/intent/tweet?text=' + title + '&url=' + url);
		$('.js-share-linkedin').attr('href', '//www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title);
	}

	Site.OnInit.push(init);

	return {
		populateUrls: populateUrls
	};
})(jQuery, Site);

window.Share = Share;

export default Share;
